module.exports = __webpack_public_path__ + "img/courseimg3.c73922ef.png";